import * as React from 'react';
import { UIHeading1, LinkButton, UIText1 } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';

import emptyIcon from './assets/empty.svg';
import * as styles from './EmptyPage.css';

interface IEmptyPageProps {
  notFoundUrl?: string;
  onNotFoundUrlClick?(): void;
}

export const EmptyPage: React.FC<IEmptyPageProps> = props => {
  const { notFoundUrl, onNotFoundUrlClick } = props;

  return (
    <div className={styles['container']}>
      <div>
        <div className={styles['image-outer']}>
          <img src={emptyIcon} alt="" className={styles['image']} />
        </div>
        <div className={styles['title-outer']}>
          <UIHeading1 textAlign="center" as="h1">
            Список сравнения пуст
          </UIHeading1>
        </div>
        <div className={styles['message-outer']}>
          <UIText1 textAlign="center">
            Чтобы сравнить квартиры, нажмите{' '}
            <span className={styles['sravnenie-icon']}>
              <IconActionCompareAdd16 color="icon-main-default" />
            </span>{' '}
            на интересном объявлении
          </UIText1>
        </div>
        <div className={styles['button-outer']}>
          {notFoundUrl && (
            <LinkButton size="XS" href={notFoundUrl} onClick={onNotFoundUrlClick}>
              Искать квартиры
            </LinkButton>
          )}
        </div>
      </div>
    </div>
  );
};
